import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../core/_base/crud';
import { PhuLieuModel } from '../phu-lieu-model/phu-lieu.model';
const API_ROOT_URL = environment.ApiRoot + '/hanghoa';
@Injectable()
export class PhuLieuService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		
		const httpHeaders = this.httpUtils.getHTTPHeaders();
			const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
			return this.http.get<any>(API_ROOT_URL + '/DM_Hanghoa_List', { 
				headers: httpHeaders,
				params: httpParams
			});
	}
	getPhuLieuById(itemId: any): Observable<any> {
		return this.http.get<any>(API_ROOT_URL + `/DM_HangHoa_Detail?Id_HH=${itemId}`);
	}
	deletePhuLieu(itemId: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url = `${API_ROOT_URL}/DM_HangHoa_Delete?Id_HH=${itemId}`;
		return this.http.post<any>(url, null, { headers: httpHeaders });
	}
	deletePhuLieus(ids: any[] = []): Observable<any> {
		const url = API_ROOT_URL + '/DM_HangHoa_Multi_Delete';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<QueryResultsModel>(url, ids, { headers: httpHeaders} );
	}
	createPhuLieu(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhuLieuModel>(API_ROOT_URL+'/DM_HangHoa_Insert', item, { headers: httpHeaders });
	}
	updatePhuLieu(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhuLieuModel>(API_ROOT_URL+'/DM_HangHoa_Update', item, { headers: httpHeaders });
	}
	updatePhuLieuDetail(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhuLieuModel>(API_ROOT_URL+'/DM_HangHoa_Update_Detail', item, { headers: httpHeaders });
	}
	uploadFilePhuLieu(data): Observable<any> {
		const url = API_ROOT_URL + '/DM_HangHoa_UploadFile';
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(url, data, { headers: httpHeaders });
	}
	importPhuLieu(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<PhuLieuModel>(API_ROOT_URL+'/DM_HangHoa_Import', item, { headers: httpHeaders });
	}
	downloadTemplate(): string {
		return API_ROOT_URL + `/DownLoadFileImportMau`;
	}
	downloadTCNPL(itemId: any): string {
		return API_ROOT_URL + `/DownLoadFileTieuChuanNPL?id=${itemId}`;
	}
	listId_NhomHH(itemId: any) : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  API_ROOT_URL + `/DM_NhomHangHoa_List?idLoaiHH=${itemId}` ;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
	listDVT1() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_DVT_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}
	listBoPhanKiemTra() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_PhongBan_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}
	listListNCC() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + '/DM_NCC_List' ;
		return this.http.post<any>(url, null , { headers: httpHeaders });
	}

	listDongSanPham() : Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const url =  environment.ApiRoot + '/danhmuc' + `/DM_DongSanPham_List?idloaihh=2` ;
		return this.http.get<any>(url, { headers: httpHeaders });
	}
}
